import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '@Services/redux/Store';
import { IDepartment } from './Interfaces';
import { initialDepartmentsState } from './State';

const DepartmentSlice = createSlice({
    name: 'Department',
    initialState: initialDepartmentsState,
    reducers: {
        updateDepartments(state, action) {
            state.departments = action.payload;
        },
    },
});

export const DepartmentActions = DepartmentSlice.actions;

export const departmentsState = (state: RootState): Array<IDepartment> | null =>
    state.department.departments;

export default DepartmentSlice.reducer;
